// hooks/useSafeToast.js
import { useRef } from 'react';
import { toast } from 'react-toastify';

const useSafeToast = () => {
    const toastRef = useRef();

    const showToast = (message, type = 'success') => {
        // Clear any existing toast first
        if (toastRef.current) {
            toast.dismiss(toastRef.current);
        }

        const options = {
            autoClose: 5000,
            closeButton: false,
            onClose: () => {
                toastRef.current = null;
            },
            onOpen: (props) => {
                toastRef.current = props.toastId;
            }
        };

        try {
            if (type === 'success') {
                return toast.success(message, options);
            } else {
                return toast.error(message, options);
            }
        } catch (error) {
            console.error('Toast error:', error);
            // Fallback to native alert
            alert(message);
            return null;
        }
    };

    return showToast;
};

export default useSafeToast;